import type { SearchIndex } from '~/modules/search';
import type { ConstantLengthArray } from '@utils-rocco/types';
import type { RangeValueFilterStateKeys } from '@modules-rocco/filters/types/filter-states';

export const SEARCH_AGGREGATE_API = '/actions/search/aggregate';

export const RANGE_DIVISORS: Record<
    (typeof RangeValueFilterStateKeys)[number],
    number
> = {
    priceRange: 100,
    lengthRange: 1000,
    widthRange: 1000,
    heightRange: 1000,
    diameterRange: 1000,
    weightRange: 1000,
};

export const DEFAULT_PAGE_SIZE = 40;

interface SearchCategoryConfig {
    children: string;
    mobileName?: string;
    category?: 'products' | 'projects' | 'professionals' | 'articles';
    index?: SearchIndex;
    categoryLink?: string;
}

export const SEARCH_CATEGORIES: ConstantLengthArray<SearchCategoryConfig, 5> = [
    {
        children: 'All',
        categoryLink: undefined,
    },
    {
        children: 'Products',
        category: 'products',
        index: 'product',
        categoryLink: '/products',
    },
    {
        children: 'Projects',
        category: 'projects',
        index: 'project',
        categoryLink: '/projects',
    },
    {
        children: 'Professionals',
        mobileName: 'Pros',
        category: 'professionals',
        index: 'professional',
        categoryLink: '/professionals',
    },
    {
        children: 'Articles',
        category: 'articles',
        index: 'blogpost',
        categoryLink: '/articles',
    },
];
